var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56537 10.5639L4.54465 7.72256C4.17674 7.3765 4.09464 6.98053 4.29834 6.53465C4.50127 6.08805 4.86415 5.86475 5.38697 5.86475H11.3703C11.8931 5.86475 12.256 6.08805 12.4589 6.53465C12.6626 6.98053 12.5805 7.3765 12.2126 7.72256L9.19191 10.5639C9.07573 10.6732 8.94987 10.7552 8.81432 10.8098C8.67878 10.8645 8.53355 10.8918 8.37864 10.8918C8.22373 10.8918 8.07851 10.8645 7.94296 10.8098C7.80742 10.7552 7.68155 10.6732 7.56537 10.5639Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDropdownArrow);
export default __webpack_public_path__ + "static/media/white_dropdown_arrow.fcd43af7a1679201c1ca5ade67290168.svg";
export { ForwardRef as ReactComponent };